import get from 'lodash/get';
import { REDUCERS_NAME } from '../../constants';

const reducerName = REDUCERS_NAME.ACTIONS;

export const selectActions = (state) => get(state, `${reducerName}.data`, {});
